export {
    getCalendarEventItemAriaLabel,
    getCalendarEventItemTitle,
} from './utils/getCalendarEventItemAttributes';
